import { SModalTitle } from "../../components/modal/Modal.styled"
import { fontVariants, styled } from "../../styles/stitches.config"

export const STitle = styled(SModalTitle, {
  ...fontVariants.headerH3,
})
